var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headingWrap row"},[_c('div',{staticClass:"headingWrap__title"},[_c('heading',{attrs:{"type":"h1","name":"slot"}},[_vm._t("title")],2)],1),_vm._v(" "),_c('div',{staticClass:"headingWrap__nav"},[_vm._t("link")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc8aae2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeadingWrap/heading-wrap.vue
// module id = null
// module chunks = 